import { render, staticRenderFns } from "./myAddrMsgMore.vue?vue&type=template&id=49c368f7&scoped=true"
import script from "./myAddrMsgMore.vue?vue&type=script&lang=js"
export * from "./myAddrMsgMore.vue?vue&type=script&lang=js"
import style0 from "./myAddrMsgMore.vue?vue&type=style&index=0&id=49c368f7&prod&lang=scss"
import style1 from "./myAddrMsgMore.vue?vue&type=style&index=1&id=49c368f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c368f7",
  null
  
)

export default component.exports